<template>
  <div class="failure-all-content">
    <div class="actions">
      <div class="retry" @click="retryAction" v-if="showRetryButton">
        重新匹配资方放款
      </div>
      <div class="refund" @click="refundAction" v-if="!isRealTimeRefund" data-sensors-click>
        去退款
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    retryAction () {
      this.$router.push('/withdraw/upcard')
    },
    refundAction () {
      this.$emit('onRefund')
    }
  },
  computed: {
    isRealTimeRefund () {
      return this.result?.upCardRealTimeRefund === 'Y'
    },
    showRetryButton () {
      return this.result?.upCardProcess === 'UP_PROCESS_MANY'
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.failure-all-content {
  .actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    .retry {
      width: 360px;
      height: 80px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 40px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 80px;
      text-align: center;
    }
    .refund {
      width: 360px;
      height: 80px;
      border-radius: 40px;
      border: 2px solid #FF4633;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FF4633;
      line-height: 80px;
      text-align: center;
      margin-top: 30px;
    }
  }
}
</style>